/**
 * 收退款渠道统计
 */

import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import intl from 'react-intl-universal';

import { Calculator, parseFen2Currency } from '@/utils/number';
import { PAYMENT_TYPE_MAP } from '@/config/constant';
import { createMapRender, PaymentChannelInfo } from '@/pages/handover/helper';

import styles from './index.module.scss';

interface IProps {
  dataSource: PaymentChannelInfo[];
}

const Index: React.FC<IProps> = (props) => {
  const dataSource = props.dataSource || [];

  const columns: ColumnsType<PaymentChannelInfo> = [
    {
      title: intl.get('handover_table_column_project'),
      dataIndex: 'paymentType',
      render: createMapRender(PAYMENT_TYPE_MAP),
    },
    {
      title: intl.get('handover_table_column_income'),
      dataIndex: 'income',
      align: 'right',
      render: (val) => parseFen2Currency(val),
    },
    {
      title: intl.get('handover_table_column_refund'),
      dataIndex: 'refund',
      align: 'right',
      render: (val) => parseFen2Currency(val),
    },
    {
      title: intl.get('handover_table_column_total'),
      align: 'right',
      render: (record) => {
        const val = new Calculator(record.income || 0);
        val.minus(record.refund || 0);
        return parseFen2Currency(val.getValue());
      },
    },
  ];

  const renderSummary = () => {
    const incomeVal = new Calculator(0);
    const refundVal = new Calculator(0);
    dataSource.forEach((item) => {
      incomeVal.plus(item.income || 0);
      refundVal.plus(item.refund);
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={1}>
          <div className="handover-table-summary-title">
            {intl.get('handover_table_summary_total')}
          </div>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} align="right">
          {parseFen2Currency(incomeVal.getValue())}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} align="right">
          {parseFen2Currency(refundVal.getValue())}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} align="right">
          {parseFen2Currency(incomeVal.minus(refundVal.getValue()).getValue())}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  return (
    <div className={styles.billChannelTable}>
      <div className="groupLabel">{intl.get('handover_bill_channel_block_title')}</div>
      <Table
        rowKey="paymentType"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        summary={renderSummary}
      />
    </div>
  );
};

export default Index;
